import orderBy from 'lodash.orderby';

import { strToDeliveryMethod } from '../components/delivery-method';
import { strToRemovalCause } from '../components/removal-cause';
import { strToStatus } from '../components/status';
import { type PickTicketsFormSchema, type PickTicketsQuerySchema } from '../schemas';

export function pickTicketsQueryToForm(data: PickTicketsQuerySchema): PickTicketsFormSchema {
  const pick_ticket_items =
    (data?.pick_ticket_items?.length ?? 0) > 0
      ? orderBy(data.pick_ticket_items, ['sort_order'], ['asc']).map((item, index) => ({
          ...item,
          sort_order: index + 1,
        }))
      : [];

  return {
    ...data,

    status: strToStatus(data?.status),
    delivery_method: strToDeliveryMethod(data?.delivery_method),
    tracking_number: data?.tracking_number ?? '',
    why_removed_comment: data?.why_removed_comment ?? '',
    notes: data?.notes ?? '',
    attached_documents: data?.attached_documents ?? [],
    remove_items: data.remove_items ?? false,
    why_removed: strToRemovalCause(data?.why_removed),
    contacts: data?.contacts?.[0] ?? null,
    pick_ticket_items,
  };
}
